module.exports = __webpack_public_path__ + "img/icon-location.5f656ec1.svg";